import React from "react"
import { useFormikContext } from "formik"
import { useOrder } from "context/order"
import Button from "components/Button"
import PackIcon from "icons/pack.svg"
import Input from "components/Input"
import { useLocale } from "context/locale"

import StyledStepThird from "./styles"

const StepThird = () => {
  const { t } = useLocale()

  const { validateForm, errors, isValid } = useFormikContext()
  const { step, setStep, checkValidation } = useOrder()

  return (
    <div className="form-step" style={step !== 3 ? { display: "none" } : {}}>
      <StyledStepThird>
        <h4 className="order-courier-form__subheader">
          {t("Provide the number of cartons")}
        </h4>
        <div className="order-boxes">
          <div className="order-courier-form__info">
            <p>
              {t(
                "Pack your clothes tightly into a cardboard box of dimensions similar to those of a cabin luggage. It will help you pack the minimum required 10 kg."
              )}
            </p>
            <p
              dangerouslySetInnerHTML={{
                __html: t(
                  "You can use a bigger cardboard box, but remember that if you order a courier, the parcel weight cannot exceed 30 kg and if you hand it over at a DPD Pickup point, one carton can weight up to 20 kg. Make sure you know how to prepare your parcel by reading our rules and regulations HERE."
                ),
              }}
            />
          </div>
          <div className="order-box">
            {errors?.boxes_amount && (
              <p className="form-error">{errors.boxes_amount}</p>
            )}
            <div className="order-box__wrapper">
              <div className="box-icon">
                <PackIcon />
              </div>
              <div className="box-form">
                <p className="box-form__label">
                  {t("Provide the number of cartons")}
                </p>
                <Input name="boxes_amount" type="number" only_numbers min={1} />
              </div>
            </div>
          </div>
        </div>
        <div className="order-courier-form__cta">
          <Button
            type="button"
            text={t("Back")}
            variant="prev"
            onClick={() => setStep(2)}
          />
          <Button
            type="button"
            text={t("Next")}
            variant="next"
            disabled={!isValid}
            onClick={async () => {
              if (checkValidation(await validateForm())) {
                setStep(4)
              }
            }}
          />
        </div>
      </StyledStepThird>
    </div>
  )
}
export default StepThird
